"use strict";

window.addEventListener("load", () => {
  if (customElements.get("slider-component")) return;
  customElements.define("slider-component", class extends HTMLElement {
    constructor() {
      super();
      this.arrowObserver = null;
      this.markerObserver = null;
      this.isSetup = false;
      this.slider = this.querySelector('[id^="Slider-"]');
      this.slides = Array.from(this.querySelectorAll("[data-slide]"));
      this.previous = this.querySelector("[data-previous]");
      this.next = this.querySelector("[data-next]");
      this.handleNext = this.handleNext.bind(this);
      this.handlePrevious = this.handlePrevious.bind(this);
      this.checkScrollability = this.checkScrollability.bind(this);
      this.init();
    }
    handleNext() {
      const position = this.slider.scrollLeft + this.slides[0].clientWidth * Number(getComputedStyle(this.slider).getPropertyValue("--movement_columns"));
      this.slider.scrollTo({
        left: position
      });
    }
    handlePrevious() {
      const position = this.slider.scrollLeft - this.slides[0].clientWidth * Number(getComputedStyle(this.slider).getPropertyValue("--movement_columns"));
      this.slider.scrollTo({
        left: position
      });
    }
    checkScrollability() {
      const isScrollable = this.slider.scrollWidth > this.slider.clientWidth;
      if (this.next) {
        this.next.setAttribute("aria-hidden", !isScrollable);
        this.next.toggleAttribute("disabled", !isScrollable);
        this.next.style.display = isScrollable ? "" : "none";
      }
      if (this.previous) {
        const isAtStart = this.slider.scrollLeft <= 0;
        this.previous.setAttribute("aria-hidden", isAtStart);
        this.previous.toggleAttribute("disabled", isAtStart);
      }
    }
    handleArrowObserver() {
      return new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (getComputedStyle(this).display === "none") return;
          const slideIndex = this.slides.indexOf(entry.target);
          const isIntersecting = entry.isIntersecting;
          if (slideIndex === 0) {
            this.previous?.setAttribute("aria-hidden", isIntersecting);
            this.previous?.toggleAttribute("disabled", isIntersecting);
          } else if (slideIndex === this.slides.length - 1) {
            this.next?.setAttribute("aria-hidden", isIntersecting);
            this.next?.toggleAttribute("disabled", isIntersecting);
          }
        }
      }, {
        root: this.slider,
        threshold: 1.0
      });
    }
    setup() {
      if (this.isSetup) return;
      this.isSetup = true;
      if (!this.previous && !this.next || !this.slides.length) return;
      this.previous?.addEventListener("click", this.handlePrevious);
      this.next?.addEventListener("click", this.handleNext);
      this.checkScrollability();
      if (!this.arrowObserver) this.arrowObserver = this.handleArrowObserver();
      this.arrowObserver.observe(this.slides[0]);
      this.arrowObserver.observe(this.slides[this.slides.length - 1]);
    }
    destroy() {
      this.isSetup = false;
      this.previous?.removeEventListener("click", this.handlePrevious);
      this.next?.removeEventListener("click", this.handleNext);
      if (this.arrowObserver) {
        this.arrowObserver.unobserve(this.slides[0]);
        this.arrowObserver.unobserve(this.slides[this.slides.length - 1]);
        this.arrowObserver.disconnect();
        this.arrowObserver = null;
      }
    }
    shouldBeActive(hoverMediaQuery) {
      if (this.hasAttribute("data-desktop") && this.hasAttribute("data-tablet")) {
        return true;
      }
      if (this.hasAttribute("data-desktop") || !this.hasAttribute("data-tablet") && !this.hasAttribute("data-desktop")) {
        return !hoverMediaQuery.matches;
      }
      if (this.hasAttribute("data-tablet")) {
        return hoverMediaQuery.matches;
      }
      return false;
    }
    init() {
      const hoverMQ = window.matchMedia("(hover: none)");
      if (this.shouldBeActive(hoverMQ)) {
        this.setup();
      }
      hoverMQ.addEventListener("change", e => {
        if (this.shouldBeActive(e)) {
          this.setup();
          this.checkScrollability();
        } else {
          this.destroy();
        }
      });
    }
  });
});